export default "__VITE_ASSET__CL86oaFf__"